import { byPrefixAndName } from "@awesome.me/kit-dde2cd9f7f/icons";

export const Icons = {
  // Address book icon
  addressBook: byPrefixAndName.fal["address-book"],

  // Grid icon
  apps: byPrefixAndName.fal["grid-2"],

  // Arrow right icon
  arrowRight: byPrefixAndName.far["arrow-right"],

  // Arrow right from bracket icon
  arrowRightFromBracket: byPrefixAndName.far["arrow-right-from-bracket"],

  // Arrow right to bracket icon
  arrowRightToBracket: byPrefixAndName.far["arrow-right-to-bracket"],

  // Arrow turn down right icon
  arrowTurnDownRight: byPrefixAndName.far["arrow-turn-down-right"],

  // Ban icon
  ban: byPrefixAndName.fal["ban"],

  // TODO: add the actual list icon to kit
  // Bars icon
  bars: byPrefixAndName.fal["bars"],

  // Boxes packing icon
  boxesPacking: byPrefixAndName.far["boxes-packing"],

  chartMixed: byPrefixAndName.fas["chart-mixed"],
  chartMixedLight: byPrefixAndName.fal["chart-mixed"],

  // Chevron down icon
  chevronDown: byPrefixAndName.far["chevron-down"],

  // Chevron right icon
  chevronRight: byPrefixAndName.far["chevron-right"],

  // Chevrons Up icon
  chevronsUp: byPrefixAndName.far["chevrons-up"],

  // Circle icon
  circle: byPrefixAndName.far["circle"],

  // Circle check icon
  circleCheck: byPrefixAndName.fas["circle-check"],

  // Circle exclamation icon
  circleExclamation: byPrefixAndName.fal["circle-exclamation"],

  // Circle info icon
  circleInfo: byPrefixAndName.fal["circle-info"],

  // Circle notch icon
  circleNotch: byPrefixAndName.far["circle-notch"],

  // Circle xmark icon
  circleXMark: byPrefixAndName.fal["circle-xmark"],

  // Clipboard check icon
  clipboardCheck: byPrefixAndName.far["clipboard-check"],

  // Clock icon
  clock: byPrefixAndName.fal["clock"],

  // Clock rotate left icon
  clockRotateLeft: byPrefixAndName.fal["clock-rotate-left"],

  // Copy icon
  copy: byPrefixAndName.fas["copy"],

  download: byPrefixAndName.fas["download"],

  // Drag Icon
  drag: byPrefixAndName.fas["grip-dots-vertical"],

  // Draw polygon icon
  drawPolygon: byPrefixAndName.fal["draw-polygon"],

  // Dropdown icon
  dropdown: byPrefixAndName.fal["square-caret-down"],

  // Earch americas icon
  earchAmericas: byPrefixAndName.fal["earch-americas"],

  // Ellipsis icon
  ellipsis: byPrefixAndName.fal["ellipsis"],

  // Exclamation triangle icon
  exclamationTriangle: byPrefixAndName.far["exclamation-triangle"],

  // Eye icons
  eye: byPrefixAndName.fal["eye"],

  eyeSlash: byPrefixAndName.fal["eye-slash"],

  faApps: byPrefixAndName.fas["grid-2"],

  fabAndroid: byPrefixAndName.fab["android"],

  fabApple: byPrefixAndName.fab["apple"],

  fabAppStoreIOS: byPrefixAndName.fab["app-store-ios"],

  // File import icon
  falFileImport: byPrefixAndName.fal["file-import"],

  farBatteryFull: byPrefixAndName.far["battery-full"],

  farCamera: byPrefixAndName.far["camera"],

  farMicrophone: byPrefixAndName.far["microphone-lines"],

  farPenToSquare: byPrefixAndName.far["pen-to-square"],

  // Calendar days icon
  fasCalendarDays: byPrefixAndName.fas["calendar-days"],

  // Car icon
  fasCarSide: byPrefixAndName.fas["car-side"],

  // Check icon
  fasCheck: byPrefixAndName.fas["check"],

  fasChevronDown: byPrefixAndName.fas["chevron-down"],

  // Chevron left icon
  fasChevronLeft: byPrefixAndName.fas["chevron-left"],

  fasChevronRight: byPrefixAndName.fas["chevron-right"],

  // Chevron double left icon
  fasChevronsLeft: byPrefixAndName.fas["chevrons-left"],

  // Chevron double right icon
  fasChevronsRight: byPrefixAndName.fas["chevrons-right"],

  // Chevron up icon
  fasChevronUp: byPrefixAndName.fas["chevron-up"],

  fasCircleExclamation: byPrefixAndName.fas["circle-exclamation"],

  fasClockRotateLeft: byPrefixAndName.fas["clock-rotate-left"],

  // Cog icon
  fasCog: byPrefixAndName.fas["cog"],

  fasEllipsis: byPrefixAndName.fas["ellipsis"],

  // Envelope icon
  fasEnvelope: byPrefixAndName.fas["envelope"],

  fasExclamationTriangle: byPrefixAndName.fas["exclamation-triangle"],

  fasFileExport: byPrefixAndName.fas["file-export"],

  // Font icon
  fasFont: byPrefixAndName.fas["font"],

  fasGlobe: byPrefixAndName.fas["globe"],

  // Hand holding dollar icon
  fasHandHoldingDollar: byPrefixAndName.fas["hand-holding-dollar"],

  fasInputNumeric: byPrefixAndName.fas["input-numeric"],

  fasInputText: byPrefixAndName.fas["input-text"],

  fasLocation: byPrefixAndName.fas["location"],

  fasLocationPin: byPrefixAndName.fas["location-pin"],

  // Message icon
  fasMessage: byPrefixAndName.fas["message"],

  fasMinus: byPrefixAndName.fas["minus"],

  fasMobile: byPrefixAndName.fas["mobile"],

  // Network wired icon
  fasNetworkWired: byPrefixAndName.fas["network-wired"],

  // Note sticky icon
  fasNoteSticky: byPrefixAndName.fas["note-sticky"],

  fasNotificationBell: byPrefixAndName.fas["bell"],

  // Pencil icon
  fasPencil: byPrefixAndName.fas["pencil"],

  fasPenField: byPrefixAndName.fas["pen-field"],

  // Phone icon
  fasPhone: byPrefixAndName.fas["phone"],

  // Photo film icon
  fasPhotoFilm: byPrefixAndName.fas["photo-film"],

  fasPlus: byPrefixAndName.fas["plus"],

  fasQuestionCircle: byPrefixAndName.fas["question-circle"],

  // Road icon
  fasRoad: byPrefixAndName.fas["road"],

  fasRoute: byPrefixAndName.fas["route"],

  // Shuffle icon
  fasShuffle: byPrefixAndName.fas["shuffle"],

  fasSignature: byPrefixAndName.fas["signature"],

  fasStickyNote: byPrefixAndName.fas["sticky-note"],

  fasTrash: byPrefixAndName.fas["trash"],

  fasTruck: byPrefixAndName.fas["truck"],

  fasUser: byPrefixAndName.fas["user"],

  fasUsers: byPrefixAndName.fas["users"],

  fasWareHouse: byPrefixAndName.fas["warehouse"],

  // File export icon
  fileExport: byPrefixAndName.fal["file-export"],

  // File image icon
  fileImage: byPrefixAndName.fal["file-image"],

  // Filter icon
  filter: byPrefixAndName.fas["filter"],

  // Flag icon
  flag: byPrefixAndName.fas["flag"],

  // Flag swallowtail icon
  flagSwallowtail: byPrefixAndName.fal["flag-swallowtail"],

  // Flask icon
  flask: byPrefixAndName.fas["flask"],

  // Form icon
  form: byPrefixAndName.fab["wpforms"],

  gear: byPrefixAndName.fas["gear"],

  gears: byPrefixAndName.fas["gears"],

  // Globe icon
  globe: byPrefixAndName.fal["globe"],

  // House icon
  house: byPrefixAndName.fal["house"],

  // Image Icon
  image: byPrefixAndName.far["image"],

  // Images icon
  images: byPrefixAndName.fal["images"],

  // Input Numeric Icon
  inputNumeric: byPrefixAndName.fal["input-numeric"],

  // Input Text Icon
  inputText: byPrefixAndName.fal["input-text"],

  // Link icon
  link: byPrefixAndName.fas["link"],

  list: byPrefixAndName.fal["list-tree"],

  // List tree icon
  listTree: byPrefixAndName.fal["list-tree"],

  locationCrossHairs: byPrefixAndName.fal["location-crosshairs"],

  // Location icons
  locationDot: byPrefixAndName.fal["location-dot"],

  locationPin: byPrefixAndName.fal["location-pin"],

  // Lock icon
  lock: byPrefixAndName.fas["lock"],

  // Magnifying glass icon
  magnifyingGlass: byPrefixAndName.far["magnifying-glass"],

  mapMarker: byPrefixAndName.fal["map-marker"],

  // Minus icon
  minus: byPrefixAndName.fal["minus"],

  // Mobile icon
  mobile: byPrefixAndName.fal["mobile"],

  // Money bill icon
  moneyBill1: byPrefixAndName.fal["money-bill-1"],

  // Notes icon
  notes: byPrefixAndName.fal["notes"],

  // Bell icon
  notificationBell: byPrefixAndName.fal["bell"],

  // Paper plane icon
  paperPlane: byPrefixAndName.fas["paper-plane"],

  // Pause icon
  pause: byPrefixAndName.fas["pause"],

  // Pen field icon
  penField: byPrefixAndName.fal["pen-field"],

  // Play icon
  play: byPrefixAndName.fas["play"],

  // Plus icon
  plus: byPrefixAndName.fal["plus"],

  // Question circle icon
  questionCircle: byPrefixAndName.fal["question-circle"],

  // Refresh icon
  refresh: byPrefixAndName.fal["arrows-rotate"],

  // Right from bracket icon
  rightFromBracket: byPrefixAndName.fal["right-from-bracket"],

  // Right to bracket icon
  rightToBracket: byPrefixAndName.fal["right-to-bracket"],

  // Route icon
  route: byPrefixAndName.fal["route"],

  sHouse: byPrefixAndName.fas["house"],

  // Signature icon
  signature: byPrefixAndName.fal["signature"],
  // Slack
  slack: byPrefixAndName.fab["slack"],

  solidCircleXMark: byPrefixAndName.fas["circle-xmark"],

  // Spinner icon
  spinner: byPrefixAndName.fal["spinner-third"],

  sTable: byPrefixAndName.fas["table"],

  // Stop icon
  stop: byPrefixAndName.fas["stop"],

  // Subtitles icon
  subtitles: byPrefixAndName.fal["subtitles"],

  // Table icon
  table: byPrefixAndName.fal["table"],

  // Terminal icon
  terminal: byPrefixAndName.fal["terminal"],

  // Timeline icon
  timeline: byPrefixAndName.fal["timeline"],

  // Trash icon
  trash: byPrefixAndName.fal["trash"],

  // Truck icon
  truck: byPrefixAndName.fal["truck"],

  // Upload icon
  upload: byPrefixAndName.fal["upload"],

  // User icon
  user: byPrefixAndName.fal["user"],

  // Users icon
  users: byPrefixAndName.fal["users"],

  // Warehouse icon
  wareHouse: byPrefixAndName.fal["warehouse"],

  wrench: byPrefixAndName.fas["wrench"],

  // Xmark icon
  xMark: byPrefixAndName.fal["xmark"],
};

export type IconsType = keyof typeof Icons;
export type IconDefinitionType = (typeof Icons)[IconsType];
